import React from 'react';
import Google from './google.svg';
import Facebook from './facebook.svg';
import Apple from './apple.svg';

export default (icon) => {
  switch (icon) {
    case 'facebook':
      return <Facebook />;
    case 'google':
      return <Google />;
    case 'apple':
      return <Apple />;
    default:
      return null;
  }
};
